import { createStandardAction } from 'typesafe-actions';

const APP_SYNC_TRIGGER_SYNC = 'APP_SYNC_TRIGGER_SYNC';

export const triggerLegacyAppSync = createStandardAction(APP_SYNC_TRIGGER_SYNC)();



// WEBPACK FOOTER //
// ./src/modules/appSync/actions.ts